import React, {useState} from "react"
import styled from "@emotion/styled";
//import { css } from "@emotion/core";
import Row, { Col } from '../components/flexgrid';
import './styles.css'


const Topnav = styled.div`
    position: fixed;
    top:0;
    width: 100%;
    z-index: 10;
    background-color: white;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.04);
`
//Change the z-index when the menu is revealed
const Name = styled.div`
    font-family: Rajdhani;
    text-transform: uppercase;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    padding:16px 24px;

`
const Menutrigger = styled.div`
    padding:16px 24px;
    font-size:24px;
    display: inline-flex;
    align-self: center;
    position: relative;
`
const Menu = styled.div`
    background: #2A4663;
    padding:24px;
    width:100vw;
    height:100vh;
    position: absolute;
    top: 0;
    left:0;
    z-index: 2;
    display: ${p => p.showMenu? "inherit":"none"};
`
const Menuitem = styled.div`
    color: white; 
    font-family: Rajdhani;
    text-transform: uppercase;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    padding:24px;
`



export default props => {
  const [showMenu, setShowMenu] = useState (false)
  function updateQuestionType (type){
    props.setQuestionType(type)
    setShowMenu(false)
    window.scrollTo(0,0)
  }
  return (
    <div>

        <Topnav>
          <Row gutterWidth="0">
            <Col>
              <Name>
                {props.questionType} Questions
              </Name>
            </Col>
            <Col fixed>
              <Menutrigger onClick={()=> {
                setShowMenu(!showMenu)
              }}>
              
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect y="11" width="24" height="2" rx="1" fill="#617080"/>
                <rect y="19" width="24" height="2" rx="1" fill="#617080"/>
                <rect y="3" width="24" height="2" rx="1" fill="#617080"/>
              </svg>
              
              </Menutrigger>
            </Col>
          </Row>
          <Menu showMenu={showMenu}>
            <Menuitem onClick={()=> updateQuestionType("Big")}>
            Big Questions
            </Menuitem>
            <Menuitem onClick={()=> updateQuestionType("Small")}>
            Small Questions
            </Menuitem>
            <Menuitem onClick={()=> updateQuestionType("Love")}>
            Love Questions
            </Menuitem>
          </Menu>
        </Topnav>

    </div>
  );
};

